import { ElementType, useState } from "react";
import { Box } from "@mui/material";
import { SmartToy } from "@mui/icons-material";
import { TextField } from "@mui/material";

interface HelperNameProps {
    name: string;
    handleInputChange: (name: string) => void;
    handleSubmit: (action: 'create' | 'update' | 'delete') => void;
}

export const HelperName: ElementType<HelperNameProps> = ({ name, handleSubmit, handleInputChange }) => {
    const [isFocused, setIsFocused] = useState(false);
    const isEmpty = name.length === 0;
    
    const getHelperText = () => {
        if (isEmpty) {
            return "required";
        }
        if (isFocused && name.length > 0) {
            return `${name.length}/50 characters`;
        }
        return ' '; // empty string 
    };
    
    return (
        <Box sx={{ 
            display: 'flex', 
            justifyContent: 'flex-start',
            flexGrow: 1,
            gap: 2, 
        }}>
            <SmartToy sx={{
                fontSize: '2.6rem',
                color: 'primary.main'
            }} />
            <TextField
                value={name}
                required
                onChange={(e) => handleInputChange(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') handleSubmit('update');
                }}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                variant="standard"
                placeholder="Enter Helper name..."
                inputProps={{
                    maxLength: 50,
                }}
                error={isFocused && isEmpty}
                helperText={getHelperText()}
                sx={{
                    flexGrow: 1,
                    '& .MuiInput-input': {
                        fontSize: '1.5rem',
                        fontWeight: 600,
                        padding: '4px 0',
                    },
                    // Hide bottom border when has value and not focused
                    '& .MuiInput-root:before': {
                        borderBottom: !isEmpty && !isFocused ? 'none' : undefined,
                    },
                    '& .MuiInput-root:hover:before': {
                        borderBottom: !isEmpty && !isFocused ? 'none !important' : undefined,
                    },
                }}
            />
        </Box>
    );
}